import type { MIconProps } from '../MIcon';
export const THEME_OPTIONS = [
  'primary',
  'custom',
  'icon',
  'icon-primary',
  'link',
  'link-underlined',
  'addon',
  'accent',
  'warning',
  'ghost',
] as const;

export const TYPE_OPTIONS = ['submit', 'button', 'reset'] as const;
export type MButton_ThemeProp = (typeof THEME_OPTIONS)[number];
export type MButton_TypeProp = (typeof TYPE_OPTIONS)[number];
export interface MButtonIconProps extends MIconProps {
  position?: 'left' | 'right';
  /**
   * Stack icon on top of button content
   */
  stack?: boolean;
}

export interface MButtonThemeProps {
  theme?: MButton_ThemeProp;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'skinny';
  width?: 'wide' | 'block';
  animation?: 'none' | 'default';
  is?: string;
  rounded?: boolean;
  loading?: boolean;
  disabled?: boolean;
}

export interface MButtonProps extends Omit<MButtonThemeProps, 'is'> {
  type?: MButton_TypeProp;
  icon?: MButtonIconProps | MIconProps['icon'];
  /**
   * Classes applied to the div that wraps the icon and button slot content.
   */
  containerClass?: string;
  rounded?: boolean;
  /**
   * The gap between the icon and the button content.
   * Tailwind gap classes are used.
   * @example 'gap-2'
   */
  iconGap?: string;
}

export const isMIconProp = (props: any): props is MIconProps['icon'] => {
  return props && 'iconName' in props;
};
